import React, { Fragment } from "react";
import { Icon } from 'antd';
import api, { AppOrgan } from "api";
import { AppButton, AppAction } from 'qcc';
import { appTree } from 'utils';
import './OrganTree.less'
import { default as OrganFormPage } from '../application/user/OrganEdit'

interface OrganTreeData extends AppOrgan {
  _tree_children?: boolean
  _tree_end?: string
  _tree_level?: number
  _tree_code?: string
  _tree_hidden?: boolean
  _tree_expand_icon?: string
}

interface OrganTreeProps {
  showButton?: boolean
  defaultExpandLevel?: number
  onClick?: (data: AppOrgan) => void
}
// 系统配置-管理中心-组织用户-组织架构
export default class extends React.Component<OrganTreeProps> {
  state = { treeData: [] as OrganTreeData[], currRow: {} as OrganTreeData }

  private toTreeData = (organList: AppOrgan[]) => {
    let treeData: OrganTreeData[] = appTree.list(organList);
    let expandLevel = this.props.defaultExpandLevel || 3;
    treeData = treeData.map((data: OrganTreeData) => {
      return {
        ...data,
        _tree_hidden: data._tree_level > expandLevel,
        _tree_expand_icon: data._tree_level < expandLevel ? 'caret-down' : 'caret-right'
      };
    })
    return treeData;
  };
  // 初始化
  async componentDidMount() {
    await this.refreshOrgan();
  }
  // 新增组织
  addOrgan = (parentOrgan: AppOrgan) => {
    let formData = { parentId: parentOrgan.id, organType: parentOrgan.organType, code: '', mdId: '', name: '' } as AppOrgan
    AppAction.openDialog(<OrganFormPage mode={1} formData={formData} extraData={parentOrgan} afterSave={this.refreshOrgan} />, { title: "新增组织架构", height: 360, width: 600 });
  }
  // 编辑组织
  editOrgan = async (organ: AppOrgan) => {
    let mode = 2;
    let parentOrgan: AppOrgan = { parentId: 0, fullCode: '' };
    if (organ.id === 1) {
      mode = 3;
    } else {
      parentOrgan = await api.apporgan.getOne({ id: organ.parentId });
    }
    let formData = await api.apporgan.getOne({ id: organ.id });
    AppAction.openDialog(<OrganFormPage mode={mode} formData={formData} extraData={parentOrgan} afterSave={this.refreshOrgan} />, { title: "编辑组织架构", height: 360, width: 600 });
  }
  // 删除组织
  deleteOrgan = async (organ: AppOrgan) => {
    if (await AppAction.confirm('您确定要删除该组织吗？')) {
      let res = await api.apporgan.delete(organ);
      if (res.result) {
        AppAction.successMsg('操作成功！');
        this.refreshOrgan();
      } else {
        AppAction.errorMsg(res.msg);
      }
    }

  }
  disabledOrgan = async (organ: AppOrgan) => {
    if (await AppAction.confirm('您确定要禁用该组织吗？')) {
      let res = await api.apporgan.disabled(organ);
      if (res.result) {
        AppAction.successMsg('操作成功！');
        this.refreshOrgan();
      } else {
        AppAction.errorMsg(res.msg);
      }
    }
  }
  enabledOrgan = async (organ: AppOrgan) => {
    if (await AppAction.confirm('您确定要启用该组织吗？')) {
      let res = await api.apporgan.enabled(organ);
      if (res.result) {
        AppAction.successMsg('操作成功！');
        this.refreshOrgan();
      } else {
        AppAction.errorMsg(res.msg);
      }
    }
  }
  // 刷新组织架构
  refreshOrgan = async () => {
    let organList = await api.apporgan.getList();
    let treeData = this.toTreeData(organList);
    if (treeData.length > 0) {
      let currRow = treeData[0];
      this.props.onClick && this.props.onClick(treeData[0]);
      this.setState({ treeData, currRow });
    }
  }

  // 行点击事件
  rowClick = (currRow: OrganTreeData) => {
    let rowDate = currRow as AppOrgan;
    this.props.onClick && this.props.onClick(rowDate);
    this.setState({ currRow });
  }

  handleTreeClick = (eventData: OrganTreeData) => {
    eventData._tree_expand_icon === 'caret-right' ? this.handleTreeExpand(eventData) : this.handleTreeShrink(eventData);
  }

  handleTreeExpand = (eventData: OrganTreeData) => {
    let treeData = this.state.treeData.map((data: OrganTreeData) => {
      if (data.id === eventData.id) {
        return { ...data, _tree_expand_icon: 'caret-down' };
      } else if (data.parentId === eventData.id) {
        return { ...data, _tree_hidden: false };
      } else {
        return { ...data };
      }
    })
    this.setState({ treeData });
  }

  handleTreeShrink = (eventData: OrganTreeData) => {
    let treeCode = eventData._tree_code;
    let treeData = this.state.treeData.map((data: OrganTreeData) => {
      if (data.id === eventData.id) {
        return { ...data, _tree_expand_icon: 'caret-right' };
      } else if (data._tree_code.indexOf(treeCode) === 0) {
        return { ...data, _tree_hidden: true, _tree_expand_icon: 'caret-right' };
      } else {
        return { ...data };
      }
    })
    this.setState({ treeData });
  }

  // 获取组织架构操作节点
  renderAction = (data: OrganTreeData) => {
    if (!this.props.showButton) return <React.Fragment />
    return (
      <div className="tree-action">
        {
          data.disabled ? <Fragment>
            <AppButton type="icon" label='删除' actionCode='00010209' iconType='delete' action={() => this.deleteOrgan(data)} />
            <AppButton type="icon" label='启用' actionCode='00010210' iconType='check-circle' action={() => this.enabledOrgan(data)} />
          </Fragment> :
            <Fragment>
              <AppButton type="icon" label='新增' actionCode='00010207' iconType='plus' action={() => this.addOrgan(data)} />
              <AppButton type="icon" label='修改' actionCode='00010208' iconType='edit' action={() => this.editOrgan(data)} />
              <AppButton type="icon" label='删除' actionCode='00010209' iconType='delete' action={() => this.deleteOrgan(data)} />
              <AppButton type="icon" label='禁用' actionCode='00010210' iconType='stop' action={() => this.disabledOrgan(data)} />
            </Fragment>
        }
      </div>
    );
  };
  // 组织树图标
  renderIcon = (rowData: OrganTreeData) => {
    if (rowData._tree_end) return <React.Fragment />
    return <span className='tree-icon' ><Icon type={rowData._tree_expand_icon} onClick={() => this.handleTreeClick(rowData)} /></span>
  }

  renderDataTypeIcon = (rowData: OrganTreeData) => {
    let className = ''
    if (rowData._tree_level === 1) {
      className = 'qcciconfont-organtree-jituan';
    } else if (rowData.organType === 1) {
      className = 'qcciconfont-organtree-gongsi';
    } else {
      className = 'qcciconfont-organtree-bumen';
    }
    return <i className={className} />
  }
  // 加载组织树
  renderTr = (rowData: OrganTreeData) => {
    let { id, _tree_end, _tree_level } = rowData
    let isSelected = this.state.currRow.id && this.state.currRow.id === id
    let blankWidth: number = _tree_end ? _tree_level : (_tree_level - 1);
    blankWidth = blankWidth * 15 + 5;
    return <tr className='tree-tr' data-selected={isSelected} hidden={rowData._tree_hidden} key={rowData.id} onClick={() => this.rowClick(rowData)}>
      <td className="tree-td" >
        <div className="tree-td-blank" style={{ width: blankWidth }}></div>
        <div className="tree-data" style={rowData.disabled ? { color: '#bbb' } : {}} title={rowData.name}>
          {this.renderIcon(rowData)}
          <span className='organ-tree-type-icon' >
            {this.renderDataTypeIcon(rowData)}
          </span>
          {rowData.name}
        </div>
        {this.renderAction(rowData)}
      </td>
    </tr >

  }
  render() {
    let { treeData } = this.state;
    return (
      <div className='app-tree-container' >
        <table style={{ width: "100%" }} cellSpacing="0" cellPadding="0">
          <tbody >
            {treeData.map((rowData) => {
              return this.renderTr(rowData);
            })}
          </tbody>
        </table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/page/public/OrganTree.tsx